import { ChatAPI } from '@guuru/chat-web';
import { client } from '@guuru/graphql-web';
import addMessagesNotYetOnAPI from './addMessagesNotYetOnAPI';
import createOrUpdateUser from './createOrUpdateUser';
import HOT_TRANSFER_CHAT from './mutations/HotTransferChat';

export default async function (partnerId, chatId) {
  const categoryId = ChatAPI.storeRetrieveCategory();
  const botPriority = ChatAPI.storeRetrieveChatPriority();

  await Promise.all([
    createOrUpdateUser(partnerId),
    addMessagesNotYetOnAPI(partnerId, chatId),
  ]);

  await client.mutate({
    mutation: HOT_TRANSFER_CHAT,
    variables: {
      id: chatId,
      input: {
        categoryId,
        botPriority,
      },
    },
  });
}
